// extracted by mini-css-extract-plugin
export default {"row":"UserInfoItem_row__GBE3x","label":"UserInfoItem_label__5NDsq","value":"UserInfoItem_value__QiGep"};